import { render, staticRenderFns } from "./bFaqView.vue?vue&type=template&id=3717e516&scoped=true"
import script from "./bFaqView.vue?vue&type=script&lang=js"
export * from "./bFaqView.vue?vue&type=script&lang=js"
import style0 from "./bFaqView.vue?vue&type=style&index=0&id=3717e516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3717e516",
  null
  
)

export default component.exports